import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, ButtonBase, FormHelperText, Grid, Stack } from "@mui/material";
import moment from "moment";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import FormEditors from "../../Forms/FormEditors";

const AdvertisementInfo = ({ formObj, handleFormChange, vehicle, isDirectSeller, error, taggings, bodyList,
    isSingPass, windowWidth, salesmanList, setVehicleDetailsOpen }) => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        // if(!formObj?.title){
        handleFormChange('title', `${vehicle?.make || ''} ${vehicle?.model || ''} ${formObj?.title_remark || ''}`);
        // }
    }, [formObj?.title_remark])

    const handleTagChange = (tagValue) => {
        const selectedTags = formObj?.taggings || [];

        if (selectedTags.includes(tagValue)) {
            const updatedTags = selectedTags.filter((tag) => tag !== tagValue);
            handleFormChange('taggings', updatedTags);
            if (formObj?.featured_tagging_id === tagValue) {
                handleFormChange('featured_tagging_id', updatedTags[0] ?? null);
            }
        } else {
            if (selectedTags.length >= 3) {
                // do nothing
            } else {
                const updatedTags = [...selectedTags, tagValue];
                handleFormChange('taggings', updatedTags);
                if (selectedTags.length === 0) {
                    handleFormChange('featured_tagging_id', tagValue);
                }
            }
        }
    }

    const handleFeaturedTagChange = (event, tagValue) => {
        event.stopPropagation();
        handleFormChange('featured_tagging_id', formObj?.featured_tagging_id === tagValue ? null : tagValue);
    }

    return (
        <React.Fragment>
            <Box className="vehicle-info-container">
                <div className="vehicle-selected-absolute">
                    Selected
                </div>
                <div className="text-semibold font-size-18 pt-2">{vehicle?.make || '-'} {vehicle?.model || ''} {vehicle?.manu_year ? (`(${vehicle?.manu_year})`) : ''}</div>
                <Box sx={{ display: { lg: 'flex', md: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between' } }}>
                    <Stack sx={{ flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' }, gap: 2, mt: 2 }}>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Reg. No:</div>
                            <div className="mx-1">{vehicle?.reg_no || '-'}</div>
                        </div>
                        {!isSingPass ?
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="subheader-2">Stock ID:</div>
                                    <div className="mx-1">{vehicle?.stock_id || '-'}</div>
                                </div> <div className="d-flex align-items-center">
                                    <div className="subheader-2">Body Type:</div>
                                    <div className="mx-1">{Array.isArray(vehicle?.body_type) && vehicle?.body_type.length > 0 ? vehicle.body_type?.map((item, idx) => bodyList?.find((body) => body.id === item)?.name).join(', ') : vehicle?.body_type || '-'}</div>
                                </div>
                            </> :
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="subheader-2">COE Expiry Date:</div>
                                    <div className="mx-1">{vehicle?.coe_expiry ? moment(vehicle?.coe_expiry, "YYYY-MM-DD").format('DD-MM-YYYY') : '-'}</div>
                                </div> <div className="d-flex align-items-center">
                                    <div className="subheader-2">No. of Owner(s):</div>
                                    <div className="mx-1">{vehicle?.no_of_owner || '0'}</div>
                                </div>
                            </>
                        }
                    </Stack>
                    <div className="d-flex align-items-end">
                        <ButtonBase onClick={() => setVehicleDetailsOpen(true)} style={{ borderRadius: 10, paddingInline: 5 }}>
                            <div className="d-flex align-items-center" style={{ color: '#B48A3C' }}>View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>
                        </ButtonBase>
                    </div>
                </Box>
            </Box>
            <Box mt={4}>
                <div className="text-semibold">Advert Title</div>
                <Grid container spacing={1}>
                    <Grid item sm={12} xs={12}>
                        <CustomTextField
                            title={'Listing Title'}
                            placeholder={'Listing Title'}
                            values={formObj?.title || ''}
                            onChange={(e) => handleFormChange('title', e)}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <CustomTextField
                            title={'Listing Title Remark'}
                            placeholder={'Listing Title Remark'}
                            values={formObj?.title_remark || ''}
                            isOptional={true}
                            subtitle={`${formObj?.title_remark ? formObj.title_remark.length : 0}/255 characters`}
                            onChange={(e) => {
                                if (e?.length <= 255) {
                                    handleFormChange('title_remark', e)
                                }
                            }}
                            error={error?.title_remark}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box mt={4}>
                <div className="text-semibold mb-2">Listing Description</div>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <FormEditors
                            value={formObj?.dealer_description || ''}
                            setValue={(e) => handleFormChange('dealer_description', e)}
                            error={error?.description}
                        />
                    </Grid>
                </Grid>
            </Box>
            {
                !isDirectSeller &&
                <Box mt={4}>
                    <div className="text-semibold">Test Ride URL <span className="optional-label me-2">Optional</span></div>
                    <Grid container spacing={1}>
                        <Grid item sm={12} xs={12}>
                            <CustomTextField
                                title={'Test Ride URL'}
                                placeholder={'Test Ride URL'}
                                values={formObj?.test_ride_url || ''}
                                onChange={(e) => handleFormChange('test_ride_url', e)}
                                error={error?.test_ride_url}
                            />
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <CustomSelect
                                title={'Person In Charge'}
                                placeholder={'Person In Charge'}
                                values={formObj?.test_ride_salesman_id || ''}
                                onChange={(e) => { handleFormChange('test_ride_salesman_id', e); }}
                                data={salesmanList || []}
                                labelName={'name'}
                                valueName={'id'}
                                error={error?.test_ride_salesman_id}
                            />
                        </Grid>
                    </Grid>
                </Box>
            }
            <Box mt={4}>
                <div className="text-semibold">Tagging <span className="optional-label me-2">Optional</span></div>
                <div className="subheader-2">
                    Select up to 3 tags. Mark one tag with a star to feature it on the mobile listing view.
                </div>
                <Stack sx={{ flexDirection: 'row', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                    {taggings.map((tag) => (
                        <div key={tag.id} className={formObj?.taggings?.includes(tag.id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleTagChange(tag.id)}>
                            {tag?.name || ''}
                            {formObj?.taggings?.includes(tag.id) && (
                                <Icon
                                    icon={formObj?.featured_tagging_id === tag.id ? "ri-star-fill" : "ri-star-line"}
                                    onClick={(event) => handleFeaturedTagChange(event, tag.id)}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter" || event.key === " ") handleFeaturedTagChange(event, tag.id);
                                    }}
                                    aria-label={formObj?.featured_tagging_id === tag.id ? `Remove ${tag.name} as featured` : `Set ${tag.name} as featured`}
                                    role="button"
                                    tabIndex={0}
                                    style={{ marginLeft: 8, color: formObj?.featured_tagging_id === tag.id ? "#D99600" : "inherit" }}
                                />
                            )}
                        </div>
                    ))}
                </Stack>
                {error?.taggings && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.taggings || ""}</FormHelperText>}
            </Box>
        </React.Fragment>
    )
}


function mapStateToProps({ General, Layout }) {
    return {
        salesmanList: General.dealer_salesmans,
        taggings: General.taggings,
        bodyList: General.bike_types,
        windowWidth: Layout.currentWidth,
    };
}

export default connect(mapStateToProps)(AdvertisementInfo);
